import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";

export class GameTitle extends Phaser.Group {

    private wreath: Phaser.Image;
    private badge: Phaser.Image;
    private pieces: Phaser.Image;
    private glowGrandmaster: Phaser.Image;
    private grandmaster: Phaser.Image;
    private chess: Phaser.Image;

    constructor(game: Phaser.Game) {

        super(game, null, "game-title");

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = 270;

        this.scale.y = GameVars.scaleY;

        this.wreath = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "splash_wreath.png");
        this.wreath.anchor.set(.5);
        this.wreath.scale.set(.8);
        this.wreath.alpha = 0;
        this.add(this.wreath);

        this.badge = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "splash_badge.png");
        this.badge.anchor.set(.5);
        this.badge.alpha = 0;
        this.badge.scale.set(.8);
        this.add(this.badge);

        // LAS PIEZAS
        this.pieces = new Phaser.Image(this.game, 0, 160, "texture_atlas_1", "splash_pieces.png");
        this.pieces.anchor.set(.5, .85);
        this.pieces.alpha = 0;
        this.pieces.scale.set(.8);
        this.add(this.pieces);

        this.chess = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "splash_chess.png");
        this.chess.anchor.set(.5);
        this.chess.alpha = 0;
        this.pieces.scale.set(.85);
        this.add(this.chess);

        // EL GLOW
        this.grandmaster = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "splash_grandmaster.png");
        this.grandmaster.anchor.set(.5);
        this.grandmaster.scale.set(.85);
        this.grandmaster.alpha = 0;
        this.add(this.grandmaster);

        this.glowGrandmaster = new Phaser.Image(this.game, 0, 105, "texture_atlas_1", "splash_glow_grandmaster.png");
        this.glowGrandmaster.anchor.set(.5);
        this.glowGrandmaster.scale.set(1.7);
        this.glowGrandmaster.alpha = 0;
        this.glowGrandmaster.blendMode = PIXI.blendModes.OVERLAY;
        this.grandmaster.addChild(this.glowGrandmaster);

        if (!GameVars.firstTimeSplash) {

            this.wreath.scale.set(1);
            this.wreath.alpha = 1;

            this.badge.scale.set(1);
            this.badge.alpha = 1;

            this.pieces.scale.set(1);
            this.pieces.alpha = 1;

            this.chess.scale.set(1);
            this.chess.alpha = 1;

            this.grandmaster.scale.set(1);
            this.grandmaster.alpha = 1;
        }
    }

    public startAnimation(): void {

        // EL ESCUDO
        this.game.add.tween(this.badge)
            .to({alpha: 1}, 400, Phaser.Easing.Cubic.Out, true);

        this.game.add.tween(this.badge.scale)
            .to({x: 1, y: 1}, 400, Phaser.Easing.Cubic.Out);

        this.game.add.tween(this.wreath)
            .to({alpha: 1}, 500, Phaser.Easing.Cubic.Out, true, 150);

        this.game.add.tween(this.wreath.scale)
            .to({x: 1, y: 1}, 500, Phaser.Easing.Cubic.Out, true, 150);

        // LAS PIEZAS
        this.game.add.tween(this.pieces)
            .to({alpha: 1}, 750, Phaser.Easing.Cubic.Out, true, 250);

        this.game.add.tween(this.pieces.scale)
            .to({x: 1, y: 1}, 750, Phaser.Easing.Cubic.Out, true, 250);

        // EL CHESS
        this.game.add.tween(this.chess)
            .to({alpha: 1}, 200, Phaser.Easing.Cubic.Out, true, 450);

        this.game.add.tween(this.chess.scale)
            .to({x: 1.15, y: 1.15}, 200, Phaser.Easing.Cubic.Out, true, 450)
            .onComplete.add(function(): void {
                this.game.add.tween(this.chess.scale)
                    .to({x: 1, y: 1}, 650, Phaser.Easing.Cubic.Out, true);
            }, this);

        // EL GRANDMASTER
        this.game.add.tween(this.grandmaster)
            .to({alpha: 1}, 200, Phaser.Easing.Cubic.Out, true, 550);

        this.game.add.tween(this.grandmaster.scale)
            .to({x: 1.1, y: 1.1}, 200, Phaser.Easing.Cubic.Out, true, 550)
            .onComplete.add(function(): void {
                this.game.add.tween(this.grandmaster.scale)
                    .to({x: 1, y: 1}, 800, Phaser.Easing.Cubic.Out, true);
            }, this);

        // EL GLOW DE GRANDMASTER
        this.game.add.tween(this.glowGrandmaster)
            .to({alpha: 1}, 150, Phaser.Easing.Cubic.Out, true, 550);

        this.game.add.tween(this.glowGrandmaster.scale)
            .to({x: 2.2, y: 2.2}, 150, Phaser.Easing.Cubic.Out, true, 550)
            .onComplete.add(function(): void {
                this.game.add.tween(this.glowGrandmaster)
                    .to({alpha: 0}, 450, Phaser.Easing.Cubic.In, true);

                this.game.add.tween(this.glowGrandmaster.scale)
                    .to({x: 1.3, y: 1.3}, 450, Phaser.Easing.Cubic.In, true)
            }, this);
    }
}
